import { render, staticRenderFns } from "./Anexo.vue?vue&type=template&id=75b5e774"
import script from "./Anexo.vue?vue&type=script&lang=js"
export * from "./Anexo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports